"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteToken = exports.getToken = exports.setBearer = exports.saveToken = exports.TOKEN_KEY = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("./config");
exports.TOKEN_KEY = 'auth';
const saveToken = ({ accessToken, expiresIn, refreshToken }) => {
    localStorage.setItem(exports.TOKEN_KEY, JSON.stringify({
        accessToken,
        expiresIn,
        refreshToken,
        saveDate: new Date()
    }));
    (0, exports.setBearer)(accessToken);
    (0, config_1.setIntervalRefreshToken)();
};
exports.saveToken = saveToken;
const setBearer = (accessToken) => {
    axios_1.default.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};
exports.setBearer = setBearer;
const getToken = () => {
    const token = localStorage.getItem(exports.TOKEN_KEY);
    if (!token)
        return null;
    try {
        return JSON.parse(token);
    }
    catch (_a) {
        (0, exports.deleteToken)();
    }
    return null;
};
exports.getToken = getToken;
const deleteToken = () => localStorage.removeItem(exports.TOKEN_KEY);
exports.deleteToken = deleteToken;
